export default __webpack_public_path__ + "static/media/icons8-html-5.c1bb84e0.svg";